import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { Overtime } from 'src/app/_model/overtime';
import { ListDocumentRequest } from 'src/app/_model/request/ListDocumentRequest';
import { PortalDocumentResponse } from 'src/app/_model/response/PortalDocumentResponse';
import { LookupService } from 'src/app/_services/lookup.service';
import { StorageService } from 'src/app/_services/storage.service';
import { TABLE_LIST } from 'src/app/_utils/constants';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-overtime-detail',
  templateUrl: './overtime-detail.component.html',
  styleUrls: ['./overtime-detail.component.sass'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatDialogModule,
    MatCheckboxModule
  ]
})
export class OvertimeDetailComponent implements OnInit {

  listDocumentRequest: ListDocumentRequest;
  portalDocumentList: PortalDocumentResponse[] = [];
  fileUploadRootPath: string;
  overtimeForm: FormGroup = this.formBuilder.group({
    overtimeType: ['', [Validators.required]],
    overtimeBranch: ['', [Validators.required]],
    overtimeProject: ['', [Validators.required]],
    overtimeTenant: [''],
    overtimeDate: ['', [Validators.required]],
    overtimeDuration: [''],
    description: ['', Validators.maxLength(500)],
    filePath: [''],
    readAndAprroved: [''],
    isRestDay: [''],
  });
  rejectReasons: any[];
  rejectDescription = '';
  selectedRejectReason: any = {};

  constructor(
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<OvertimeDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private storageServie: StorageService,
    private cdr: ChangeDetectorRef,
    private lookupService: LookupService) {
    this.fileUploadRootPath = environment.fileUploadPath;
  }

  ngOnInit() {
    this.listDocumentRequest = new ListDocumentRequest(TABLE_LIST.OVERTIME, this.data.id);
    this.storageServie.listDocuments(this.listDocumentRequest).subscribe(documentListResult => {
      this.portalDocumentList = [...documentListResult.responseData.items];
      this.cdr.detectChanges();
    });
    this.rejectReasons = this.lookupService.localOvertimeRejectReasonLookupList();
    this.rejectDescription = this.rejectReasons.find(x => x.id === this.data.overtimeTypeId).lookupDescription;
  }

  closeModal() {
    this.dialogRef.close();
  }

}
